export default __webpack_public_path__ + "static/media/4_hotel_champ.521a3bce.svg";